<template>
  <div v-if="challengeDetail && challengeDetail.Id">
    <div class="solution">
      <div class="text-center" v-if="loading">
        <CSpinner color="info" />
      </div>
    </div>

    <CCard v-if="solutions && solutions.length">
      <CCardHeader class="py-1">
        <i class="fas fa-comments"></i>&nbsp;
        <strong>Solutions</strong>
      </CCardHeader>
      <CCardBody class="px-3 py-2">
        <div
          v-for="(item, i) in solutions"
          :key="`solution-${i}`"
          class="solution-item"
          :class="{ 'border-top pt-2': i > 0 }"
        >
          <div class="form-row">
            <div class="col-9">
              <p class="mb-1">{{ item.Title }}</p>
              <div class="text-muted small">
                <i class="fas fa-clock"></i>
                {{ showDateTime(item.UpdatedAt) }}
                &nbsp;|&nbsp;
                <i class="fas fa-user"></i>
                {{
                  item.IsAnonymous ? "Anonymous" : item.CreatedByNavigation.Name
                }}
                &nbsp;|&nbsp;
                <a
                  href="javascript:"
                  class="text-muted"
                  @click="showingVoteId = item.Votes ? item.Id : 0"
                >
                  <i class="far fa-thumbs-up"></i>
                  {{ item.Votes ? item.Votes : 0 }} likes
                </a>
              </div>

              <div class="description short py-2">
                <pre :class="{ 'more-info': item.seeMore }">
                  {{ item.Description }}
                </pre>
                <span
                  v-if="!item.seeMore"
                  role="button"
                  class="see-more text-muted"
                  @click="item.seeMore = true"
                >
                  <strong>...see more</strong>
                </span>
              </div>

              <div class="attached" v-if="item.AttachedFiles">
                <ul style="list-style-type: none" class="p-0">
                  <li
                    v-for="(file, i) in getFileNames(item)"
                    :key="`file-${i}`"
                  >
                    <a
                      :href="`${$http.defaults.baseURL}/Document/download/SipIdea$${item.Id}/${file.fileName}`"
                      target="_blank"
                      class="text-dark"
                    >
                      <i
                        :class="`fas ${file.icon}`"
                        style="font-size: 1.2rem"
                      ></i>
                      {{ file.fileName }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-3 position-relative">
              <a
                href="javascript:"
                class="text-muted d-block"
                v-if="item.working"
              >
                <i class="fas fa-thumbs-up"></i>
                Like
              </a>
              <a
                v-else-if="item.SipIdeaVotes && item.SipIdeaVotes.length"
                href="javascript:"
                class="text-primary d-block"
                @click="unvoteIdea(item)"
              >
                <i class="fas fa-thumbs-up"></i>
                Like
              </a>
              <a
                v-else
                href="javascript:"
                class="text-muted d-block"
                @click="voteIdea(item)"
              >
                <i class="fas fa-thumbs-up"></i>
                Like
              </a>

              <a
                v-if="
                  item.Status == $const.IDEA_STATUS.New &&
                  sipUser &&
                  sipUser.UserId == item.CreatedBy
                "
                href="javascript:"
                class="text-muted d-block mt-1"
                @click="
                  editing = true;
                  solutionId = item.Id;
                "
              >
                <i class="fas fa-edit"></i>
                Edit
              </a>
              <a
                v-if="
                  item.Status == $const.IDEA_STATUS.New &&
                  sipUser &&
                  sipUser.UserId == item.CreatedBy
                "
                href="javascript:"
                class="text-danger d-block mt-1"
                @click="deleteSolution(item)"
              >
                <i class="fas fa-trash"></i>
                Delete
              </a>
              <span
                v-if="item.Status == $const.IDEA_STATUS.Approved"
                class="text-success d-inline-block text-nowrap position-absolute"
                style="bottom: 5px; right: 0"
              >
                <i class="fas fa-check-double"></i>
                Approved
              </span>
              <a
                v-else-if="managerId && item.Status == $const.IDEA_STATUS.New"
                href="javascript:"
                class="text-muted d-inline-block text-nowrap position-absolute"
                style="bottom: 5px; right: 0"
                @click="solutionApprovingId = solutionApprovingId ? 0 : item.Id"
              >
                <i class="fas fa-check"></i>
                Approve
              </a>
            </div>
          </div>
          <div
            v-if="solutionApprovingId == item.Id"
            class="solution-approve mb-2"
          >
            <div class="form-row">
              <div class="col">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Reason"
                  v-model="solutionReason"
                />
              </div>
              <div class="col-auto">
                <button
                  :class="`btn btn-sm btn-success`"
                  @click="approveSolution(solutionApprovingId)"
                >
                  <i class="fas fa-check"></i>
                  Approve
                </button>
              </div>
              <div class="col-auto">
                <button
                  class="btn btn-secondary btn-sm"
                  @click="
                    solutionApprovingId = 0;
                    solutionReason = null;
                  "
                >
                  <i class="fas fa-close"></i>
                  Cancel
                </button>
              </div>
            </div>
          </div>

          <div
            v-if="
              [$const.IDEA_STATUS.Approved].includes(item.Status) &&
              item.ReasonByNavigation
            "
            :class="`small text-${
              $const.IDEA_STATUS_TEXT[item.Status].color
            } mb-2`"
          >
            <i class="fas fa-check-double"></i>
            {{ $const.IDEA_STATUS_TEXT[item.Status].text }} on
            {{ $moment(item.ReasonAt).format("DD MMM YYYY, HH:mm") }} by
            {{ item.ReasonByNavigation.FirstName }}
            <br />
            <i class="far fa-comment"></i>
            {{ item.Reason }}
          </div>
        </div>
      </CCardBody>
    </CCard>

    <editPop
      :editing.sync="editing"
      :ideaId.sync="solutionId"
      :challenge="challengeDetail"
      @reload="reloadInfo"
    />

    <votesPopup :entityId.sync="showingVoteId" />
  </div>
</template>

<script>
import editPop from "../idea/Popup.vue";
import votesPopup from "@/components/sipVotes.vue";

export default {
  props: ["challengeDetail", "sipUser", "managerId", "addingSolution"],
  components: {
    editPop,
    votesPopup,
  },
  data() {
    return {
      solutions: [],
      editing: false,
      loading: false,
      solutionId: 0,
      solutionApprovingId: 0,
      solutionReason: null,
      showingVoteId: 0,
    };
  },
  created: function () {
    this.$messageHub.$on("IdeaVoteChange", this.ideaVoteChange);
  },
  beforeDestroy: function () {
    //clean SignalR event
    this.$messageHub.$off("IdeaVoteChange", this.ideaVoteChange);
  },
  mounted() {
    this.loadSolutions(this.challengeDetail.Id);
  },
  watch: {
    challengeDetail(val) {
      if (val) {
        this.loadSolutions(val.Id);
      }
    },
    addingSolution(val) {
      if (val) {
        this.editing = true;
        this.solutionId = 0;
      }
    },
    editing(val) {
      if (!val) {
        this.$emit("update:addingSolution", false);
      }
    },
  },
  methods: {
    async loadSolutions(challengeId) {
      this.loading = true;

      try {
        let solutions = [];
        let userId = this.sipUser ? this.sipUser.UserId : 0;
        let filter = [];
        filter.push(
          `SipIdeaOfChallenges/any(f:f/ChallengeId eq ${challengeId})`
        );

        let params = {
          $select:
            "Id,Title,Description,AttachedFiles,UpdatedAt,CreatedBy,Status,Votes,Reason,ReasonAt,IsAnonymous",
          $filter: filter.join(` and `),
          $expand: `CreatedByNavigation($select=Name,Email),SipIdeaVotes($top=1;$select=Id;$filter=UserId eq ${userId}),SipIdeaOfChallenges($top=0;$filter=ChallengeId eq ${challengeId}),ReasonByNavigation($select=FirstName)`,
          $orderby: `Status Desc, UpdatedAt desc`,
        };

        let resp = await this.$http.get(`odata/SipIdea`, {
          params,
        });
        if (resp && resp.status == 200) {
          solutions =
            resp.data.value && resp.data.value.length
              ? resp.data.value.map((_) => {
                  _.seeMore = false;
                  _.working = false;
                  return _;
                })
              : [];
        }
        this.solutions = solutions;
      } catch (error) {
        alert(error);
      }

      this.loading = false;
    },

    async reloadInfo(solutionId) {
      if (solutionId) {
        let item = null;
        let userId = this.sipUser ? this.sipUser.UserId : 0;
        let params = {
          $top: 1,
          $filter: `Id eq ${solutionId}`,
          $select:
            "Id,Title,Description,AttachedFiles,UpdatedAt,CreatedBy,Status,Votes,IsAnonymous",
          $expand: `Area($select=Name),CreatedByNavigation($select=Name,Email),SipIdeaVotes($top=1;$select=Id;$filter=UserId eq ${userId}),SipIdeaOfChallenges($top=0)`,
        };
        let resp = await this.$http.get(`odata/SipIdea`, {
          params,
        });
        if (resp && resp.status == 200) {
          let record =
            resp.data.value && resp.data.value.length
              ? resp.data.value.map((_) => {
                  _.seeMore = false;
                  _.working = false;
                  return _;
                })[0]
              : null;
          if (record) {
            item = record;
          }
        }

        if (item) {
          let index = this.solutions.findIndex((_) => _.Id == solutionId);
          this.$set(this.solutions, index, item);
        }
      } else {
        this.loadSolutions(this.challengeDetail.Id);
      }
    },

    async voteIdea(idea) {
      idea.working = true;
      try {
        let resp = await this.$http.post(`odata/SipIdeaVote`, {
          IdeaId: idea.Id,
        });
        if (resp && resp.status == 201) {
          //idea.Votes = idea.Votes ? idea.Votes + 1 : 1;
          idea.SipIdeaVotes = [{ Id: resp.data.Id }];
        }
      } catch (error) {
        console.log(error);
      }
      idea.working = false;
    },

    async unvoteIdea(idea) {
      idea.working = true;
      try {
        let voteId =
          idea.SipIdeaVotes && idea.SipIdeaVotes.length
            ? idea.SipIdeaVotes[0].Id
            : 0;
        if (voteId) {
          let resp = await this.$http.delete(`odata/SipIdeaVote/${voteId}`);
          if (resp && resp.status == 204) {
            //idea.Votes = idea.Votes && idea.Votes > 0 ? idea.Votes - 1 : 0;
            idea.SipIdeaVotes = [];
          }
        }
      } catch (error) {
        console.log(error);
      }
      idea.working = false;
    },

    async ideaVoteChange({ entityId, votes }) {
      let idea = this.solutions.find((_) => _.Id == entityId);
      if (idea) {
        idea.Votes = votes;

        // load vote state
        idea.working = true;
        try {
          let resp = await this.$http.get(`odata/SipIdeaVote`, {
            params: {
              $top: 1,
              $select: "Id",
              $filter: `IdeaId eq ${idea.Id}`,
            },
          });
          if (resp && resp.status == 200) {
            idea.SipIdeaVotes = resp.data.value;
          }
        } catch (error) {
          console.log(error);
        }
        idea.working = false;
      }
    },

    getFileNames(detail) {
      let result = [];
      if (detail && detail.AttachedFiles) {
        let attachedFiles = detail.AttachedFiles;
        let files = JSON.parse(attachedFiles);
        if (files && files.length) {
          result = files
            .map((_) => {
              let icon =
                _.endsWith(".xlsx") || _.endsWith(".xls")
                  ? "fa-file-excel"
                  : _.endsWith(".docx") || _.endsWith(".doc")
                  ? "fa-file-word"
                  : _.endsWith(".pdf")
                  ? "fa-file-pdf"
                  : "fa-file-image";
              return { icon, fileName: _ };
            })
            .filter((_) => _.icon);
        }
      }
      return result;
    },

    truncateHtmlString(trunc, len) {
      let result = "";
      if (trunc.length > len) {
        /* Truncate the content of the P, then go back to the end of the
   previous word to ensure that we don't truncate in the middle of
   a word */
        result = trunc.substring(0, len);
        result = result.replace(/\w+$/, "");

        /* Add an ellipses to the end and make it a link that expands
   the paragraph back to its original size */
        trunc +=
          '<a href="#" ' +
          'onclick="this.parentNode.innerHTML=' +
          "unescape('" +
          escape(trunc) +
          "');return false;\">" +
          "...</a>";
        return result;
      } else {
        return trunc;
      }
    },

    showDateTime(createdAt) {
      return this.$moment().diff(this.$moment(createdAt), "weeks") < 1
        ? this.$moment(createdAt).fromNow()
        : this.$moment(createdAt).format("DD MMM YYYY, HH:mm");
    },

    async approveSolution(solutionId) {
      if (solutionId) {
        if (!this.solutionReason) {
          alert("Reason is required!");
          return;
        }

        let resp = await this.$http.patch(`odata/SipIdea/${solutionId}`, {
          Status: this.$const.IDEA_STATUS.Approved,
          Reason: this.solutionReason,
          ReasonAt: new Date().toISOString(),
          ReasonBy: this.managerId,
        });
        if (resp && resp.status == 204) {
          let res = await this.$http.patch(
            `odata/SipChallenge/${this.challengeDetail.Id}`,
            {
              Status: this.$const.CHALLENGE_STATUS.Solved,
            }
          );
          if (res && res.status == 204) {
            this.reloadInfo(solutionId);
            this.$emit("reload");
          }
        }

        this.solutionReason = null;
        this.solutionApprovingId = 0;
      }
    },

    async deleteSolution(item) {
      if (confirm("Do you really want to delete this solution?")) {
        if (item.Status == this.$const.IDEA_STATUS.New) {
          // remove files
          let frmData = new FormData();
          frmData.append("Id", item.Id);
          frmData.append("IsReplaced", true);
          frmData.append("EntityName", "SipIdea");

          await this.$http.post("/SipFile", frmData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          let resp = await this.$http.delete(`/odata/SipIdea/${item.Id}`);
          if (resp && resp.status == 204) {
            // reload
            this.$emit("reload");
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.description {
  position: relative;

  pre {
    white-space: pre-line;
    font-family: inherit;
    font-size: 14px;
    width: 100%;
    margin-bottom: 0;
    height: 4rem;
    overflow: hidden;

    &.more-info {
      height: unset;
      min-height: 4rem;
    }
  }

  .see-more {
    position: absolute;
    bottom: 0.3rem;
    right: 0;
    overflow: hidden;
    background: #fff;
    padding-left: 10px;
  }
}
</style>
